module.exports = __webpack_public_path__ + "img/tagshai.56ee2708.svg";